import {Fragment, useState} from 'react';

import {Button} from 'primereact/button';

import {useCellEditing} from '../../../../shared/hooks/CellEditing';
import {ToastService} from '../../../../AppToast';

import {TenantInvoiceSettingMasterService} from '../TenantInvoiceSettingMasterService';

import DialogFormulas from './DialogFormulas';

export const Settings = (props) => {

  const dataKey = 'id';

  const {items, setItems, invoiceGroups, allSettings, group, sortItems, tenantInvoiceSettingMasterId} = props;

  const [displayFormulas, setDisplayFormulas] = useState(0);
  const [selectedSetting, setSelectedSetting] = useState(null);
  const [formulaField, setFormulaField] = useState(null);
  const [formulasField, setFormulasField] = useState(null);

  const typeFormats = [
    {value: 'formatQuantity', label: 'Số lượng'},
    {value: 'formatPrice', label: 'Đơn giá'},
    {value: 'formatTotal', label: 'Tổng tiền'},
    {value: 'formatTaxDetail', label: 'Thuế chi tiết'},
    {value: 'formatTaxAmount', label: 'Tổng tiền thuế'}
  ];
  const groupTypeCodes = [
    {value: '00', label: '00'},
    {value: '01', label: '01'},
    {value: '02', label: '02'},
    {value: '03', label: '03'},
    {value: '04', label: '04'},
    {value: '06', label: '06'}
  ];
  const groupXMLs = [
    {value: '01', label: 'Phí, lệ phí'},
    {value: '02', label: 'Thông tin khác'},
    {value: '03', label: 'Giảm trừ KCT'},
    {value: '04', label: 'Giảm trừ khác'}
  ];

  const showFormulas = (setting: any, formulaField: string, formulasField: string) => {
    setSelectedSetting(setting);
    setFormulaField(formulaField);
    setFormulasField(formulasField);
    setDisplayFormulas(Date.now);
  }
  const labelWidth = (window.innerWidth * 0.2) + 'px';

  const columns: any = [
    {field: 'lable', header: 'Tên trường', editable: true, style: {minWidth: labelWidth, maxWidth: labelWidth}},
    {field: 'fieldName', header: 'Tên biến', style: {minWidth: '200px', maxWidth: '200px'}},
    {field: 'orders', header: 'Thứ tự', dataType: 'number', editable: true, style: {minWidth: '90px', maxWidth: '90px'}},
    {field: 'lableWidth', header: 'Độ rộng label', dataType: 'number', editable: true, style: {minWidth: '130px', maxWidth: '130px'}},
    {field: 'controlWidth', header: 'Độ rộng giá trị', dataType: 'number', editable: true, style: {minWidth: '140px', maxWidth: '140px'}},
    {field: 'maxLength', header: 'Giới hạn ký tự', dataType: 'number', editable: true, style: {minWidth: '110px', maxWidth: '110px'}},
    {
      field: 'typeFormat', header: 'Thập phân', dataType: 'dropdown', editable: true, inputProps: {options: typeFormats}, style: {minWidth: '120px', maxWidth: '120px'},
      checkEditable: (rowData) => {
        return rowData.dataType === 'int32';
      }
    },
    {field: 'use', header: 'Sử dụng', dataType: 'checkbox', editable: true, style: {minWidth: '80px', maxWidth: '80px'}, className: 'text-center'},
    {field: 'readOnly', header: 'Cho phép sửa', dataType: 'checkbox', editable: true, style: {minWidth: '100px', maxWidth: '100px'}, className: 'text-center'},
    {
      field: 'formulaLabel', header: 'Công thức', style: {minWidth: '150px'}, dataType: 'custom', customCell(rowData: any): any {
        if (rowData.useFormula) {
          if (rowData.formula) {
            return (<span className="text-primary pointer p-1" onClick={() => {
              showFormulas(rowData, 'formula', 'formulas')
            }}>{rowData.formula}</span>);
          } else {
            return (<span className="text-primary pointer p-1" onClick={() => {
              showFormulas(rowData, 'formula', 'formulas')
            }}>Lập công thức</span>);
          }
        } else {
          return '';
        }
      }
    },
    {field: 'multipleFormula', header: 'Multy công thức', dataType: 'checkbox', editable: true, style: {minWidth: '110px', maxWidth: '110px'}, className: 'text-center'},
    {field: 'groupTypeCode', header: 'Nhóm', dataType: 'dropdown', editable: true, inputProps: {options: groupTypeCodes}, style: {minWidth: '90px', maxWidth: '90px'}},
    {field: 'required', header: 'Bắt buộc nhập', dataType: 'checkbox', editable: true, style: {minWidth: '110px', maxWidth: '110px'}, className: 'text-center'},
    {
      field: 'formulaLabel2', header: 'Công thức Excel', style: {minWidth: '150px'}, dataType: 'custom', customCell(rowData: any): any {
        if (rowData.useFormula) {
          if (rowData.formulaExcel) {
            return (<span className="text-primary pointer p-1" onClick={() => {
              showFormulas(rowData, 'formulaExcel', 'formulasExcel')
            }}>{rowData.formulaExcel}</span>);
          } else {
            return (<span className="text-primary pointer p-1" onClick={() => {
              showFormulas(rowData, 'formulaExcel', 'formulasExcel')
            }}>Lập công thức</span>);
          }
        } else {
          return '';
        }
      }
    },
    {field: 'lableExportExcel', header: 'Tiêu đề cột Excel', editable: true, style: {minWidth: '120px', maxWidth: '120px'}},
    {field: 'ordersFormula', header: 'Thứ tự tính', dataType: 'number', editable: true, style: {minWidth: '110px', maxWidth: '110px'}},
    {field: 'defaultValue', header: 'Giá trị Excel', editable: true, style: {minWidth: '120px', maxWidth: '120px'}},
    {field: 'groupXML', header: 'Nhóm XML', dataType: 'dropdown', editable: true, inputProps: {options: groupXMLs, showClear: true}, style: {minWidth: '150px', maxWidth: '150px'}}
  ];

  switch (group) {
    case '00':
    case '01':
    case '02':
    case '03':
    case '04':
      columns[3].header = columns[3].header + ' (/12)';
      columns[4].header = columns[4].header + ' (/12)';
      break;
    case '05':
      columns[3].header = 'Độ rộng (px)';
      columns[4].invisible = true;
      break;
    case '06':
      columns[3].header = columns[3].header + ' (/100)';
      columns[4].header = columns[4].header + ' (/100)';
      break;
  }

  const {render: renderDataTable} = useCellEditing({
    dataKey,
    columns,
    items: items || [],
    onCellChange: (rowData, column, newValue) => {
      const _items = [...items];
      for (const _item of _items) {
        if (_item[dataKey] === rowData[dataKey]) {
          _item[column.field] = newValue;
        }
      }
      setItems(group, _items);
    }
  });

  const refreshItems = () => {
    sortItems(group);
  }

  const saveItems = () => {
    TenantInvoiceSettingMasterService.updateByGroup(tenantInvoiceSettingMasterId, group, items).then(() => {
      ToastService.success();
    });
  }

  const onFormulasSubmit = () => {
    setDisplayFormulas(0);
  }

  return (
    <Fragment>
      <div className="mb-1">
        <Button icon="pi pi-refresh" label="Sắp xếp" className="p-button-outlined mr-2" onClick={refreshItems}/>
        {tenantInvoiceSettingMasterId &&
					<Button icon="pi pi-save" label="Lưu" className="p-button-outlined p-button-success" onClick={saveItems}/>
        }
      </div>
      {renderDataTable()}
      {selectedSetting &&
          <DialogFormulas display={displayFormulas} setting={selectedSetting} formulaField={formulaField} formulasField={formulasField} invoiceGroups={invoiceGroups} allSettings={allSettings}
                          onSubmit={onFormulasSubmit}/>
      }
    </Fragment>
  );
}